
<div class="nsw-container nsw-p-bottom-sm" style="margin-bottom:1rem">
    <nav aria-label="Breadcrumbs" class="nsw-breadcrumbs">
        <ol>
            <ng-container *ngFor="let item of Locations; let i = index">
                <ng-container *ngIf="item?.target">
                    <li >                        
                        <a class="bread-crumb-link" [routerLink]="item.target">{{item.label}}</a>
                    </li>
                </ng-container>
                <ng-container *ngIf="!item?.target">
                    <li>  
                        <a href="javascript:void(0)" class="current" aria-current="page">{{item.label}}</a>
                    </li>
                </ng-container>                
            </ng-container>
            <li>                
                <a href="javascript:void(0)" class="current" aria-current="page">{{current}}</a>
            </li>
        </ol>
    </nav>
</div>
